"use strict";
// Copyright (C) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupPositioning = void 0;
var GroupPositioning;
(function (GroupPositioning) {
    /** @member {string} */
    /** Default, focus group does not affect child positioning */
    GroupPositioning["Disabled"] = "disabled";
    /** @member {string} */
    /** Focus group will be positioned instead of children if it fits within the bounds of the screen. */
    GroupPositioning["Enabled"] = "enabled";
    /** @member {string} */
    /** Focus group will be positioned instead of children always. */
    GroupPositioning["Forced"] = "forced";
})(GroupPositioning || (exports.GroupPositioning = GroupPositioning = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ3JvdXBQb3NpdGlvbmluZy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90eXBlcy9ncm91cFBvc2l0aW9uaW5nLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSw0REFBNEQ7OztBQUU1RCxJQUFZLGdCQVVYO0FBVkQsV0FBWSxnQkFBZ0I7SUFDeEIsdUJBQXVCO0lBQ3ZCLDZEQUE2RDtJQUM3RCx5Q0FBcUIsQ0FBQTtJQUNyQix1QkFBdUI7SUFDdkIscUdBQXFHO0lBQ3JHLHVDQUFtQixDQUFBO0lBQ25CLHVCQUF1QjtJQUN2QixpRUFBaUU7SUFDakUscUNBQWlCLENBQUE7QUFDckIsQ0FBQyxFQVZXLGdCQUFnQixnQ0FBaEIsZ0JBQWdCLFFBVTNCIn0=